import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list",
  "use": "list-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 10\" id=\"list\"><rect width=\"12\" height=\"2\" rx=\"1\" /><rect width=\"12\" height=\"2\" y=\"4\" rx=\"1\" /><rect width=\"12\" height=\"2\" y=\"8\" rx=\"1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol